module.exports = __webpack_public_path__ + "static/img/price4.576e8e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/price4.png
// module id = g5MF
// module chunks = 36